import * as React from "react";
import {useTranslation} from "react-i18next";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";


export default function PageInternalServer() {
  const {t} = useTranslation()
  const location = useLocation();


  return (
     <>
       <div className="ErrorPage">
         <img src={require('../assets/img/500.png')} alt="500" loading="lazy"/>

         <h2>Error 500</h2>
         <p>به نظر میرسه سرورمون رفته یه چایی بخوره و برگرده.</p>

         <div className="btnGroup_yellow m-0">
           <Link to={{pathname: '/tracking', search: location?.search}} className="btnFill justify-content-center" id="tracking">
             <span>{t("forgetPassword.t6")}</span>
           </Link>
         </div>

       </div>
     </>
  )
}
